import db from "../../../db";

export const deleteUnauthenticatedDraftBasket = async ({
  supplierId,
}: {
  supplierId: number;
}) => {
  const draftOrder = await db.draftOrders.get({
    RetailerId: 0,
    SupplierId: supplierId,
    initiator: "retailer",
  });

  if (!draftOrder) return;

  return db.draftOrders
    .where({
      RetailerId: 0,
      SupplierId: supplierId,
      initiator: "retailer",
    })
    .delete();
};
